import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import FooterIllustration from 'components/FooterIllustration';
import UnauthenticatedPage from 'components/UnauthenticatedPage';
import { Button } from "@blueprintjs/core";
import { Helmet } from 'react-helmet';
import { TopNavbar } from 'components/Styles';
import MainSiteLogo from 'components/MainSiteLogo';
import NewUserSidebar from './new_user_sidebar';

@inject('viewStore', 'userStore') @observer
class SignupCompanyType extends Component {

  @observable isDisabled = true;

  componentDidMount() {
    this.checkNextButton();
  }

  handleCompanyTypeChange(event) {
    const {
      userStore: {
        signup: {
          object
        }
      }
    } = this.props;
    object.company_type = event.target.value;
    this.checkNextButton();
  }

  checkNextButton() {
    const {
      userStore: {
        signup: {
          object
        }
      }
    } = this.props;
    if(object.company_type !== '') {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.navigateToNextScreen()
    }
  }

  navigateToNextScreen() {
    const {
      viewStore
    } = this.props;
    viewStore.signupCompanyTeamSize();
    this.props.userStore.saveUserSignupToLocalStorage();
  }

  render() {
    const {
      viewStore,
      userStore: {
        signup: {
          object
        }
      }
    } = this.props;
    return(
      <UnauthenticatedPage>
        <Helmet>
          <title>Signup | FieldNexus</title>
        </Helmet>
        <TopNavbar>
          <div className="tp-nav">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-7">
                  <MainSiteLogo />
                </div>
                <div className="col-5 text-right">
                  <div className="right-link-tp">
                    <div className="top-btn-back"><a onClick={() => viewStore.signupCompany()}><img src="/back.svg" title="Go Back" alt='Back' /> Go Back</a> 3/5</div>
                  </div>
                </div>
              </div>
            </div>      
          </div>
        </TopNavbar>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-9 d-flex align-items-center sign-up">
            <div className="form-wrap">
              <p>Introduce your business</p>
              <h3 className="login-heading">Lets select your business industry.</h3>
              <div className="row input-wrap">
                <div className="col-sm-12">
                  <select 
                    autoFocus 
                    className="form-control" 
                    value={object.company_type} 
                    onChange={this.handleCompanyTypeChange.bind(this)} 
                    defaultValue={object.company_type} 
                    onKeyPress={this.onEnter.bind(this)}
                  >
                    <option value="">Select from popular industries</option>
                    <option value="Appliance Repair">Appliance Repair</option>
                    <option value="Carpet Cleaning">Carpet Cleaning</option>
                    <option value="Commercial Cleaning">Commercial Cleaning</option>
                    <option value="Electrical Cleaning">Electrical Cleaning</option>
                    <option value="General Contracting">General Contracting</option>
                    <option value="HVAC">HVAC</option>
                    <option value="Landscaping">Landscaping</option>
                    <option value="Presure Washing">Presure Washing</option>
                    <option value="Residential Cleaning">Residential Cleaning</option>
                    <option value="Pest Control">Pest Control</option>
                    <option value="Plumbing">Plumbing</option>
                    <option value="Snow Removing">Snow Removing</option>
                    <option value="Painting">Painting</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-sm-6 col-5 fg-pass">
                  <a onClick={() => viewStore.signupCompany()}>Previous Step</a>
                </div>
                <div className="col-sm-6 col-7 fg-next">
                  <Button
                    className="btn-gray"
                    disabled={this.isDisabled}
                    onClick={this.navigateToNextScreen.bind(this)} >
                    Next
                  </Button>
                </div>
              </div>
              <h6 className="d-none d-sm-none d-md-block text-right">Or Press ENTER</h6>
            </div>
            </div>
            <div className="col-lg-3">
              <NewUserSidebar />
            </div>
          </div >
        </div >
        
        <FooterIllustration />
      </UnauthenticatedPage>
    )
  }

};

export default SignupCompanyType;